import {
  Box,
  Dropdown,
  DropdownButton,
  DropdownOption,
  DropdownOptionList,
  TextWithIcon,
  Tooltip,
} from '@modusign/design-system';
import { ReactNode } from 'react';

interface RoleOptions<T> {
  roleName: T;
  name: string;
  content: string;
  icon: ReactNode;
}

export interface ResourceRoleTypeSelectProps<T> {
  roleOptions: RoleOptions<T>[];
  selectedRoleName: T;
  setSelectedRoleName: (roleName: T) => void;
}

function ResourceRoleTypeSelect<T extends string>({
  roleOptions,
  selectedRoleName,
  setSelectedRoleName,
}: ResourceRoleTypeSelectProps<T>) {
  return (
    <Dropdown
      readOnly={roleOptions.length === 1}
      width="100px"
      onChange={(value) => setSelectedRoleName(value as T)}
    >
      <DropdownButton>
        {roleOptions.find((label) => label.roleName === selectedRoleName)?.name}
      </DropdownButton>
      <DropdownOptionList bg="white" width="140px">
        {roleOptions.map((label) => (
          <Tooltip content={label.content} key={label.name} placement="left" scale="md">
            <Box>
              {/* FIXME(org3): DropdownOption이 Tooltip이 children이 될 수 있게끔, ForwardRef로 감싼 ref를 받는 컴포넌트로 수정 필요 */}
              <DropdownOption key={label.name} value={label.roleName}>
                <span>
                  <TextWithIcon color="textNeutralSlightlyLight" leftIcon={label.icon}>
                    {label.name}
                  </TextWithIcon>
                </span>
              </DropdownOption>
            </Box>
          </Tooltip>
        ))}
      </DropdownOptionList>
    </Dropdown>
  );
}

export default ResourceRoleTypeSelect;
